module.exports = __webpack_public_path__ + "img/guigang.8a24745d.png";